export default __webpack_public_path__ + "static/media/onyinye-mystash-v2Podcast.8fd46513.png";